import { MutationTree } from "vuex";
import { PaymentRequirementsOutgoingState } from "./interface";

export default <MutationTree<PaymentRequirementsOutgoingState>> {}